import { render, staticRenderFns } from "./estadisticas.vue?vue&type=template&id=9a9100a0&scoped=true"
import script from "./estadisticas.vue?vue&type=script&lang=js"
export * from "./estadisticas.vue?vue&type=script&lang=js"
import style0 from "./estadisticas.vue?vue&type=style&index=0&id=9a9100a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9100a0",
  null
  
)

export default component.exports